
































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: {
    InfiniteLoading,
  },
})
export default class ScrollableTableCellFilter extends Mixins() {
  @Prop({ default: () => [] as string[] })
  columnCells: string[];

  @Prop()
  initialFilterText: string;

  data(): any {
    return {
      filterText: this.initialFilterText ? this.initialFilterText : "",
      filterItems: [] as string[],
      loadedCells: [] as string[],
    };
  }
  filterText: string;
  filterItems: string[];
  loadedCells: string[];

  infiniteLoading: InfiniteLoading;
  chunkedCount: number;
  loadChunkSize: number = 50;

  get enabledColumnCells(): boolean {
    return (this.columnCells.length > 1);
  }

  get enabledFilterItems(): boolean {
    return (this.filterItems.length > 0) &&
      (this.filterItems.length !== this.columnCells.length);
  }

  resetChunkList(): void {
    this.loadedCells = [];
    this.chunkedCount = 0;
    this.infiniteLoading = this.$refs.infiniteLoading as InfiniteLoading;
    this.infiniteLoading.stateChanger.reset();
  }

  onInfinite(): void {
    this.chunkList();
  }

  private chunkList(): void {
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.columnCells.length) {
        this.infiniteLoading.stateChanger.complete();
        return;
      }
      this.loadedCells.push(this.columnCells[i]);
    }
    this.chunkedCount += this.loadChunkSize;
    this.infiniteLoading.stateChanger.loaded();
  }

  selectAll(): void {
    this.filterItems = this.columnCells;
  }

  cancelAll(): void {
    this.filterItems = [];
  }

  @Watch("filterText")
  onFilterTextUpdated(newValue: string, oldValue: string) {
    this.$emit("filterTextChanged", newValue);
  }

  @Watch("filterItems")
  onFilterItemsUpdated(newValue: string[], oldValue: string[]) {
    this.$emit("filterItemsChanged", newValue);
  }

  @Emit("enterKeyDown")
  onEnterKeyDown(): void {}
}
